import {Types} from 'mongoose';
import {APPROVAL_STATUS_APPROVED, APPROVAL_STATUS_PENDING, APPROVAL_STATUS_REJECTED} from './approval-status.consts';

export const APPROVAL_STATUS = {
    type: 'Approval Status',
    category: 'System',
    value: [APPROVAL_STATUS_PENDING, APPROVAL_STATUS_APPROVED, APPROVAL_STATUS_REJECTED].map(d => ({
        ...d,
        id: new Types.ObjectId(d._id),
        active: true,
    })),
};
